import { styled } from '@mui/material';
import Box from '@mui/material/Box';

import { colors } from '../../styles';

export const Text = styled(Box)`
  font-size: 18px;
  line-height: 20px;
  color: ${colors.mainGray};
`;

export const VacanciesTitle = styled('h3')`
  font-size: 18px;
  font-weight: 500;
`;

export const VacanciesShortList = styled('ul')`
  margin-top: 16px;
  padding-left: 22px;

  li {
    margin-top: 8px;
    font-size: 16px;

    a {
      text-decoration: none;
      color: ${colors.blue};
    }
  }
`;
